import { Injectable } from '@angular/core';
import { LogI } from 'sharedweb/app.interface';
import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { SocketConnections, SocketCommands } from 'sharedweb/app.structs';
import { HttpClient } from '@angular/common/http';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { LogLevel, LogType } from './logging.structs';
import { SocketService } from '../socket/socket.service';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {

    constructor(
        private _socketService: SocketService,
        private _http: HttpClient
    ) { }

    get appLoggingLevel() {
        return SharedUtils.storageHelper.appLogLevel || LogLevel.INFO;
    }

    sendLog(log: LogI, logLevel = LogLevel.INFO) {
        log.log = `${logLevel} :- ${log.log}`;
        if (this._socketService.isConnected(SocketConnections.order)) {
            this._socketService.send(SocketConnections.order, {
                command: SocketCommands.logs,
                log
            });
        } else {
            this._http.post(applicationUrls.logger, log).subscribe();
        }
    }

    logInactivity() {
        this.sendLog({
            log: `Logged out due to inactivity.`,
            time: this.getDate(),
            user_id: SharedUtils.storageHelper.userInfo.username,
            log_type: LogType.inactivityLog
        });
    }

    debug(logMessage: any) {
        if (this.appLoggingLevel === LogLevel.DEBUG) {
            this.sendLog({
                log: JSON.stringify(logMessage),
                log_type: LogType.log,
                time: this.getDate(),
                user_id: SharedUtils.storageHelper.userInfo.username
            }, LogLevel.DEBUG);
        }
    }

    getDate() {
        return new Date().toString();
    }
}
